import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { BookPrintResponse } from '../../responses/platform/book-print.response';
import { BookPrintSelectedRequest } from '../../requests/platform/book-print-selected.request';
import { BookPrintSelectedResponse } from '../../responses/platform/book-print-selected.response';
import { ShoppingCartPostRequest } from '../../requests/platform/shopping-cart-post.request';
import { ShoppingCartPostResponse } from '../../responses/platform/shopping-cart-post.response';
import { GetKitPaymentResponse } from '../../responses/platform/get-kit-payment.response';
import { GetKitPaymentCouponResponse } from '../../responses/platform/get-kit-payment-coupon.response';
import { GetAuthorDiscountResponse } from '../../responses/platform/get-author-discount.response';

@Injectable({
  providedIn: 'root'
})
export class KitPaymentService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public post(shoppingCartPostRequest: ShoppingCartPostRequest): Observable<ShoppingCartPostResponse> {
    return this.http
      .post<ShoppingCartPostResponse>(environment.urlApiPlatform + "KitPayment", shoppingCartPostRequest, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public get(idKitPayment: number): Observable<GetKitPaymentResponse> {
    return this.http
      .get<GetKitPaymentResponse>(environment.urlApiPlatform + "KitPayment/idKitPayment/" + idKitPayment, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getCoupon(couponCode: string, idKit: number): Observable<GetKitPaymentCouponResponse> {
    return this.http
      .get<GetKitPaymentCouponResponse>(environment.urlApiPlatform + `KitPayment/couponCode/${couponCode}/idKit/${idKit}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getAuthorDiscount(idKit: number): Observable<GetAuthorDiscountResponse> {
    return this.http
      .get<GetAuthorDiscountResponse>(environment.urlApiPlatform + `KitPayment/author-discount/idKit/${idKit}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
